import { Badge } from '@/components/ui/badge'
import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'
import { TransactionValidationState } from 'api/Wallet/Types/TransactionValidations'
import { parseToHTML } from 'helpers/generic/parser'

import styles from './TransactionValidations.module.scss'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

export const TransactionValidationsColumns: GridColumn[] = [
  {
    title: 'Name',
    field: 'paymentOption.name',
    show: true,
    width: 330,
  },
  {
    title: 'Status',
    show: true,
    width: 120,
    cell: (props: GridCellProps): JSX.Element => {
      const validationPassed = props.dataItem.state.id === TransactionValidationState.Succeeded
      return (
        <td>
          <Badge variant={validationPassed ? 'green' : 'red'}>{props.dataItem.state.name}</Badge>{' '}
        </td>
      )
    },
  },
  {
    title: 'Log',
    show: true,
    cell: (props: GridCellProps): JSX.Element => {
      const parsedLog = parseToHTML(props.dataItem.log.html)
      return (
        <td>
          <details className={styles.details}>
            <summary>
              <span>{props.dataItem.log.text.slice(0, 50)}</span>
            </summary>
            <span dangerouslySetInnerHTML={{ __html: parsedLog }} />
          </details>
        </td>
      )
    },
  },
]
